import React from 'react';

import { getApplicableL2CompanyModules } from 'Deer/components/navigation/secondary/Company/CompanyModules';
import { CompetenciesIntentDropdown } from 'Deer/intent/Competencies/components/CompetenciesIntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { CompetencySettings as CompetencySettingsComponent } from 'screens/admin/Competencies/CompetencySettings/CompetencySettings';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

interface Props {}

const CompetencySettings = (props: Props) => {
  const { moduleName } = useOrganisationSettings();
  const applicableL2CompanyModules = getApplicableL2CompanyModules(moduleName) ?? [];

  if (checkIntentLandingPagesFeatureEnabled()) {
    return (
      <Layout
        Filters={
          <CompetenciesIntentDropdown
            breadcrumbs={{
              items: [
                {
                  label: 'Company',
                  to: applicableL2CompanyModules[0]?.value,
                },
              ],
              page: {
                label: 'Competencies',
                to: '',
              },
            }}
          />
        }
      >
        <CompetencySettingsComponent />
      </Layout>
    );
  }
  return null;
};

export { CompetencySettings };
